export const MODULE = "custom-delivery-docket-print-modal";
